<template>
    <div style="margin:0 10px">
        <router-view></router-view> 
        <div class="card">
            <!-- search -->
            <div class="search d-flex a-center">
                
                <div style="width:160px;margin-right:10px;">
                    <el-input type="text" v-model="query.name" placeholder="名称" class="search-input"></el-input>  
                </div>
                <el-button class="search-button" @click="init"></el-button>
                <el-button class="add-button" @click="$router.push({name:'agent_add'})"></el-button>
            </div>

            <!-- handle -->
            <div class="handle"></div>

            <!-- table -->
            <div class="table" style="margin-top:20px;">
                <el-table
                    :data="tableData"
                    style="width: 100%;"
                    v-loading="loading"
                    element-loading-background="rgba(255,255,255, 0.6)"
                    :header-cell-style="{background:'#f8f8f9',color:'#606266',borderBottom:'1px solid #e8eaec',padding:'8px 0',fontWeight:'700'}"
                >
                    <el-table-column prop="name" label="代理商名称" align="center"></el-table-column>
                    <el-table-column prop="contacts" label="联系人" align="center"></el-table-column>
                    <el-table-column prop="" label="联系人电话" align="center">
                        <template slot-scope="scope" v-if="scope.row.manager">
                            <span>{{ scope.row.manager.phone }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="联系地址" align="center"></el-table-column>
                    <el-table-column prop="" label="管理员账号" align="center">
                        <template slot-scope="scope" v-if="scope.row.manager">
                            <span>{{ scope.row.manager.username }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="操作" align="center" width="180">
                        <template slot-scope="scope">
                            <el-button @click="$router.push({name:'agent_edit',query:{id:scope.row.id}})" type="text" size="small" class="edit-action">编辑</el-button>
                            <el-popconfirm
                                style="margin-left: 10px;"
                                title="是否确定删除？"
                                @confirm="handleDel(scope.row)"
                            >
                                <el-button type="text" slot="reference" size="small" class="delete-action">删除</el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- page -->
                <div style="margin-top:20px;text-align:center">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, sizes"
                        :total="total"
                        :page-sizes="pageSizes"
                        :page-size="query.size"
                        @size-change="onSize"
                        @current-change="onCurrPage"
                        @prev-click="onCurrPage"
                        @next-click="onCurrPage"
                    >
                    </el-pagination>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {lists,del} from '@/request/api/agent.js'
export default {
    data(){
        return {
            tableData: [],
            query:{name:'',page:1,size:10},
            pageSizes:[10,30,50,100],
            total:0 , //列表总数
            loading:false,
            isEdit:false ,//编辑状态
        }
    },
    watch:{
        $route(val ,old){
            //返回刷新
            if(val.name=='agent') {
                this.init()
            }
        }
    },

    created(){
        this.init()
    },

    methods:{
        init(){
            lists(this.query).then(res=>{
                this.tableData = res.data.list
            })
        },

        //删除
        handleDel(data){
            del({id:data.id}).then(res=>{
                if(res.code!=0) return this.$notify.error({title:'错误',message: res.msg});
                this.init()
                this.$notify({title: '成功',message: res.msg,type: 'success'});
            })
        },
        
        //每页条数
        onSize(val){
            this.query.size=val
            this.init()
        },
        onCurrPage(val){
            this.query.page = val
            this.init()
        }
    }
}
</script>


<style scoped lang="less">
.card {
    // background-color: #fff;
    border-radius: 4px;
    padding: 20px;
}

</style>

